import e from "@dialpad/dialtone-tokens/layered/themes/tokens-melon-colors.css?inline";
//#region themes/melon.js
var t = {
	brand: {
		css: e,
		name: "melon"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
